import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import classes, { StyledTableCell } from "../../styles/CheckinFormStyle";
import { Stack } from "@mui/system";
import { Box, Typography } from "@mui/material";
import WR from "../../assets/images/WR.svg";
import PositionedMenu from "./Menu";
import { columns } from "../../utilities/CheckinForm";

export default function StickyHeadTable({ data }: any) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  //Handled Pagination
  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={classes.tableClass}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead sx={classes.tableHead}>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  sx={classes.tableCell}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

              .map((row: any) => {
                return (
                  <TableRow
                    sx={{ borderRadius: "1rem", overflow: "hidden" }}
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                  >
                    <StyledTableCell>
                      <Stack direction="row" gap="2rem" alignItems="center">
                        <Box sx={classes.tableName}>
                          {" "}
                          <img src={WR} alt="" />
                        </Box>
                        <Box sx={{ textTransform: "capitalize" }}>
                          {row?.title}
                          <Typography>{row?.created}</Typography>
                        </Box>
                      </Stack>
                    </StyledTableCell>
                    <StyledTableCell>
                      {row?.checkInFormQuestions.length}
                    </StyledTableCell>
                    {/* <StyledTableCell>{row?.Responses}</StyledTableCell>
                    <StyledTableCell>{row?.Completion}</StyledTableCell> */}
                    <StyledTableCell>
                      {row?.isActivated ? "Activated" : "Deactivated"}
                    </StyledTableCell>
                    <StyledTableCell>
                      <PositionedMenu
                        isActivated={row?.isActivated}
                        id={row?.id}
                      />
                    </StyledTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{
          "& .MuiSvgIcon-root": {
            width: "2.5rem",
            height: "2.5rem",
          },
          "& .MuiTablePagination-displayedRows": {
            fontSize: "1.8rem",
          },
        }}
        rowsPerPageOptions={[10]}
        component="div"
        count={data?.length ? data?.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
